import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Helmet({ titleData, descriptionData, canonicalPath }) {
  const location = useLocation();

  useEffect(() => {
    // Title
    if (titleData) {
      document.title = titleData;
    }

    // Meta description
    let metaDesc = document.querySelector("meta[name='description']");
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }

    if (descriptionData) {
      metaDesc.setAttribute("content", descriptionData);
    }

    // ✅ Canonical (always set)
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }

    const baseUrl = "https://classicinsides.com";

    const finalPath =
      canonicalPath || location.pathname;

    canonical.setAttribute("href", baseUrl + finalPath);

  }, [titleData, descriptionData, canonicalPath, location.pathname]);

  return null;
}

export default Helmet;